import React, { FunctionComponent } from 'react';
import { useLocation } from 'react-router';
import makeLink from 'helper/make-link';
import { isMainRouteActive } from 'core/nav/helpers';

import SidebarNavGroup from 'ui/molecules/sidebar-group/sidebar-nav-group';

import SidebarNavLink from 'core/nav/sidebars/nav-list/nav-link';
import { NavigationItem } from 'core/nav/types';
import Spacer from 'src/ui/atoms/spacer';

const SidebarNavList: FunctionComponent<{
  navigationItems: NavigationItem[];
  className?: string;
  wide?: boolean;
}> = ({ navigationItems, className, wide }) => {
  const location = useLocation();

  return (
    <SidebarNavGroup className={className}>
      {navigationItems.map(({ route, subRoutes, label, params }, index) => {
        if (!route?.path?.length) {
          return (
            <React.Fragment key={index}>
              <Spacer y={10} />
              <SidebarNavLink link={null} active={false}>
                {label}
              </SidebarNavLink>
            </React.Fragment>
          );
        }
        return (
          <SidebarNavLink
            key={makeLink(route, params)}
            link={makeLink(route, params)}
            active={isMainRouteActive(route, subRoutes, location.pathname)}
            wide={wide}
          >
            {label}
          </SidebarNavLink>
        );
      })}
    </SidebarNavGroup>
  );
};

export default SidebarNavList;
